import * as React from "react"
import Svg, { SvgProps, Path, Circle } from "react-native-svg"
const ReUploadIconv2 = (props: SvgProps) => (
  <Svg

  width={24}
  height={24}
  fill="none"
  {...props}
>
  <Circle
    cx={12}
    cy={12}
    r={11.722}
    fill="#C0A46F"
    stroke="#FDFBF9"
    strokeWidth={0.556}
  />
  <Path
    fill="#FDFBF9"
    d="m8.668 15.73-.388-.398L11.603 12 8.28 8.668l.388-.397L12 11.603l3.332-3.332.388.397L12.397 12l3.323 3.332-.388.397L12 12.397l-3.332 3.332Z"
  />
</Svg>
)
export default ReUploadIconv2
